import * as React from 'react';

export function IconAd() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 80 80">
      <path fill="#0468FF" fillOpacity=".15" d="M0 24L32 8l32 16v56H0V24z" />
      <path fill="#0468FF" d="M16 40h64v40H16z" />
      <path fill="#fff" d="M24 48h24v24H24zM52 48h20v2H52zM52 54h20v2H52zM52 60h12v2H52z" />
    </svg>
  );
}
